import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import CaseStudiesLegalContent from './../components/CaseStudies/CaseStudiesLegalContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const CaseStudiesLegal = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {

    document.title = t('case-studies-legal-page.case-studies-legal-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesLegalContent/>     
    </>
  )
}

export default CaseStudiesLegal